import { render, staticRenderFns } from "./UserBadgeWithAvatar.vue?vue&type=template&id=6c786934&scoped=true&"
import script from "./UserBadgeWithAvatar.vue?vue&type=script&lang=ts&"
export * from "./UserBadgeWithAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./UserBadgeWithAvatar.vue?vue&type=style&index=0&id=6c786934&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c786934",
  null
  
)

export default component.exports